import StateOffcanvas from '../Offcanvas'
import { GroupSelect } from 'GroupSelect'
import NamedCheckbox from '../NamedCheckbox'
import { useSettings } from 'Settings'

export function OrangePanel({ handle, onHide }) {
	const [settings] = useSettings()
	const usb = settings['usb']

	const usb_source_options = [
		{value : 0, label : 0},
		{value : 5, label : 5},
		{value : 10, label : 10},
		{value : 20, label : 20}
	]

	return (
		<StateOffcanvas handle={handle} onHide={onHide} trigger="orange" title="USB Settings">
			<GroupSelect
				name="Charging Source"
				options={usb_source_options}
				unit="mA"
				value={usb['charging source'].value}
				onChange={(v) => usb['charging source'].setValue(v.value)}
			/>
			<NamedCheckbox
				name="Force HRV_LOW Hi-Z"
				value={usb['force hrv_low hi-z'].value}
				onChange={(e) => usb['force hrv_low hi-z'].setValue(e.target.checked)}
			/>
			<NamedCheckbox
				name="Force BAT_LOW Hi-Z"
				value={usb['force bat_low hi-z'].value}
				onChange={(e) => usb['force bat_low hi-z'].setValue(e.target.checked)}
			/>
			<NamedCheckbox
				name="Always disable USB LDO"
				value={usb['always disable usb ldo'].value}
				onChange={(e) => usb['always disable usb ldo'].setValue(e.target.checked)}
			/>
		</StateOffcanvas>
	)
}
